(function ($) {
	$(document).ready(function () {
		const $maps = $('.community-groups-map');

		if (!$maps.length) {
			return;
		}

		$maps.each(function () {
			const $map = $(this);

			setUpMap($map);
			buildMap($map);
		});
	});

	function setUpMap($map) {
		if (typeof window.communityMaps === 'undefined') {
			window.communityMaps = {};
		}

		let mapId = $map.attr('id');

		if (!mapId) {
			mapId = 'map-' + Math.random().toString(36).substr(2, 9);
			$map.attr('id', mapId);
		}

		const coords = $map.data('coords');
		const zoom = $map.data('zoom');

		window.communityMaps[mapId] = L.map(mapId).setView(coords, zoom);

		window.communityMaps[mapId].scrollWheelZoom.disable();

		const layer =
			'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=cb1_3wnc_1_2147934920dab5708cf3ba66';
		// const layer =
		// 	'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}';

		L.tileLayer(layer, {
			attribution: '&copy; <a href="https://carto.com/attributions">CARTO</a>',
		}).addTo(window.communityMaps[mapId]);
	}

	function buildMap($map) {
		const id = $map.attr('id');
		const $markers = $map.data('markers');

		// remove data-markers attribute
		$map.removeAttr('data-markers');
		const LOWER_LIMIT = 100;
		const UPPER_LIMIT = 200;
		const MARKER_SZIE = 25;

		var markersCluster = L.markerClusterGroup({
			maxClusterRadius: 60,
			// hide the polygon that shows the cluster bounds
			showCoverageOnHover: false,
			iconCreateFunction: function (cluster) {
				// Adapted from https://github.com/Leaflet/Leaflet.markercluster/blob/master/src/MarkerClusterGroup.js#L821-L834
				var childCount = cluster.getChildCount();

				var c = ' marker-cluster-';
				if (childCount < LOWER_LIMIT) {
					c += 'small';
				} else if (childCount < UPPER_LIMIT) {
					c += 'medium';
				} else {
					c += 'large';
				}

				return new L.DivIcon({
					html:
						'<div><span>' + childCount + ' <span aria-label="markers"></span>' + '</span></div>',
					className: 'marker-cluster' + c,
					iconSize: new L.Point(40, 40),
				});
			},
		});

		if ($markers) {
			$markers.forEach((marker) => {
				var dot = L.divIcon({
					className: `map-icon`,
					type: 'div',
					html: '',
					popupAnchor: [0, -15], // point from which the popup should open relative to the iconAnchor
					iconSize: [MARKER_SZIE, MARKER_SZIE],
					iconAnchor: [MARKER_SZIE / 2, MARKER_SZIE / 2],
				});
				const myMarker = L.marker([marker.lat, marker.lng], { icon: dot });
				// myMarker.addTo(window.communityMaps[id]);
				markersCluster.addLayer(myMarker);

				// give it a popup
				var markerText = `<div class="community-grup-popup">
        <h2 class="has-heading-4-font-size"><a href="${marker.permalink}">${marker.title}</a></h2>
        <p>${marker.excerpt}</p>
        <a href="${marker.permalink}">View community group page</a></div>`;

				myMarker.bindPopup(markerText, {
					// autoPan: false,
					maxWidth: 241,
					minWidth: 241,
				});
			});

			window.communityMaps[id].addLayer(markersCluster);
		}

		// add geojson of area
		const geojsonUrl = $map.data('geojson-url');
		if (geojsonUrl) {
			$.getJSON(geojsonUrl, function (data) {
				const geojsonLayer = L.geoJSON(data).addTo(window.communityMaps[id]);

				// fit map to bounds
				window.communityMaps[id].fitBounds(geojsonLayer.getBounds(), { maxZoom: 11 });
			});
		}
	}
})(jQuery);
